"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputEventBindContext = void 0;
var tslib_1 = require("tslib");
var code_enum_1 = require("./code.enum");
var InputEventBindContext = /** @class */ (function () {
    function InputEventBindContext(service) {
        this.currentEventSymbols = [];
        /**
         * @deprecated Use the {@link Code} enum directly.
         */
        this.Code = tslib_1.__assign(tslib_1.__assign({}, code_enum_1.Code), { AllKeys: undefined });
        this.em = service;
    }
    InputEventBindContext.prototype.on = function (code, fn, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var eventDescriptor = {
            code: code,
            modifiers: {
                ctrl: (_b = (_a = options === null || options === void 0 ? void 0 : options.modifiers) === null || _a === void 0 ? void 0 : _a.ctrl) !== null && _b !== void 0 ? _b : false,
                shift: (_d = (_c = options === null || options === void 0 ? void 0 : options.modifiers) === null || _c === void 0 ? void 0 : _c.shift) !== null && _d !== void 0 ? _d : false,
                alt: (_f = (_e = options === null || options === void 0 ? void 0 : options.modifiers) === null || _e === void 0 ? void 0 : _e.alt) !== null && _f !== void 0 ? _f : false,
                meta: (_h = (_g = options === null || options === void 0 ? void 0 : options.modifiers) === null || _g === void 0 ? void 0 : _g.meta) !== null && _h !== void 0 ? _h : false
            },
            eventType: (_j = options === null || options === void 0 ? void 0 : options.eventType) !== null && _j !== void 0 ? _j : 'keydown'
        };
        var symbol = this.em.on(this, eventDescriptor, fn);
        this.currentEventSymbols.push(symbol);
        return symbol;
    };
    InputEventBindContext.prototype.off = function (symbol) {
        var index = this.currentEventSymbols.findIndex(function (currentEventSymbol) { return currentEventSymbol === symbol; });
        if (index > -1) {
            this.currentEventSymbols.splice(index, 1);
        }
        return this.em.off(this, symbol);
    };
    InputEventBindContext.prototype.destroy = function () {
        var _this = this;
        this.currentEventSymbols.forEach(function (currentEventSymbol) { return _this.em.off(_this, currentEventSymbol); });
        this.currentEventSymbols = [];
    };
    return InputEventBindContext;
}());
exports.InputEventBindContext = InputEventBindContext;
//# sourceMappingURL=event.context.js.map